<template>
  <div class="cart-grouped-row">
    <p class="cart-grouped-number">{{ index + 1 }}.</p>
    <div class="form-grouped-group form-grouped-group--card">
      <div class="form-group form-group--is-placeholder form-group--is-select form-group--service">
        <select id="serviceType" class="form-control" v-model="formDatas.serviceType" @change="onUpdateTotal">
          <option value="certification">{{ Translator('front.cart.add.type_certification') }}</option>
          <option value="authentication">{{ Translator('front.cart.add.type_authentication') }}</option>
          <option value="re_evaluation">{{ Translator('front.cart.add.type_re_evaluation') }}</option>
        </select>
      </div>
      <div class="form-group form-group--is-placeholder form-group--is-select form-group--game" :class="{'is-not-empty': formDatas.game}"
        v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-game'); onScroll = false; }}">
        <v-select v-model="formDatas.game" :options="games" :reduce="game => game && game['@id'] ? game['@id'] : null" label="name" @input="onChangeGame()"
           ref="select-game" @search:blur="onBlurVueSelect('select-game')" @search:focus="onFocusVueSelect('select-game')" @option:selected="onSelectedVueSelect('select-game'); onChangeGame()">
          <template v-slot:selected-option="option">
            <img :src="option.image.url" :alt="option.name" v-if="option.image">
          </template>
          <template v-slot:option="option">
            <img :src="option.image.url" :alt="option.name" v-if="option.image">
          </template>
        </v-select>
      </div>
      <div class="form-group form-group--is-placeholder form-group--is-select form-group--language" :class="{'is-not-empty': formDatas.language}"
        v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-language'); onScroll = false; }}">
        <v-select v-model="formDatas.language" :options="[...languages]" :reduce="language => language && language['@id'] ? language['@id'] : null" label="code" @input="onChangeLanguage()"
           ref="select-language" @search:blur="onBlurVueSelect('select-language')" @search:focus="onFocusVueSelect('select-language')" @option:selected="onSelectedVueSelect('select-language'); onChangeLanguage()">
          <template v-slot:selected-option="option">
            <img :src="option.image.url" :alt="option.code" v-if="option.image">
          </template>
          <template v-slot:option="option">
            <img :src="option.image.url" :alt="option.code" v-if="option.image">
          </template>
        </v-select>
      </div>
    </div>
    <div class="form-grouped-group form-grouped-group--extension">
      <template v-if="currentGame && (currentGame.code === 'pokemon' || currentGame.code === 'magic')">
        <div class="form-group form-group--is-placeholder form-group--is-select form-group--extension" v-if="!isLoadExtensions && extensions"
        :class="{'is-not-empty': formDatas.extension, 'is-help': helps && helps.extension, 'is-error': form.items.$dirty && form.items.$each.$response.$data[index].extension.$error}"
        v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-extension'); onScroll = false; }}">
          <div class="form-label-container">
            <label :for="'extension-' + index">{{ currentGame && currentGame.extensionLabel ? currentGame.extensionLabel : Translator('front.cart.add.card.extension')}}</label>
          </div>
          <v-select :options="[...extensions]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="formDatas.extension" label="name"
            ref="select-extension" @search:blur="onBlurVueSelect('select-extension')" @search:focus="onFocusVueSelect('select-extension')" @option:selected="onSelectedVueSelect('select-extension');">
            <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
          </v-select>
          <div class="form-card-help" v-if="helps && helps.extension">
            <button type="button" id="help-extension" @click="onShowHelp($event, helps.extension)">
              <i class="ico ico-help"></i>
              <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
            </button>
          </div>
        </div>
        <div class="card-grouped-loader" v-if="isLoadExtensions"></div>
      </template>
      <template v-else>
        <div class="form-group form-group--is-placeholder form-group--is-select form-group--extention" v-if="!isLoadExtensionsCode && extensionsCode"
        :class="{'is-not-empty': formDatas.extensionCode, 'is-help': helps && helps.extensionCode, 'is-error': form.items.$dirty && form.items.$each.$response.$data[index].extensionCode.$error}"
        v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-extensionCode'); onScroll = false; }}">
          <div class="form-label-container">
            <label :for="'extensionCode-' + index">{{ currentGame && currentGame.extensionCodeLabel ? currentGame.extensionCodeLabel : Translator('front.cart.add.card.extension_code')}}</label>
          </div>
          <v-select :options="[...extensionsCode]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="formDatas.extensionCode" label="name"
            ref="select-extensionCode" @search:blur="onBlurVueSelect('select-extensionCode')" @search:focus="onFocusVueSelect('select-extensionCode')" @option:selected="onSelectedVueSelect('select-extensionCode');">
            <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
          </v-select>
          <div class="form-card-help" v-if="helps && helps.extensionCode">
            <button type="button" id="help-extensionCode" @click="onShowHelp($event, helps.extensionCode)">
              <i class="ico ico-help"></i>
              <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
            </button>
          </div>
        </div>
        <div class="card-grouped-loader" v-if="isLoadExtensionsCode"></div>
      </template>
    </div>
    <div class="form-grouped-group form-grouped-group--extension-number">
      <div class="form-group form-group--is-placeholder form-group--extension-number"
          v-if="(formDatas.extension || formDatas.extensionCode) && !isLoadExtensions && !isLoadExtensionsCode"
        :class="{'is-not-empty': formDatas.customExtensionNumber, 'is-help': helps && helps.customExtensionNumber, 'is-error': form.items.$dirty && form.items.$each.$response.$data[index].customExtensionNumber.$error}">
        <div class="form-label-container">
          <label :for="'number-' + index">{{ Translator('front.cart.add.card.customExtensionNumber_short')}}</label>
        </div>
        <input type="text" class="form-control" v-model="formDatas.customExtensionNumber" @focus="onFocus" @blur="onBlur" :id="'number-' + index" autocomplete="off">
        <div class="form-card-help" v-if="helps && helps.customExtensionNumber">
          <button type="button" id="help-customExtensionNumber" @click="onShowHelp($event, helps.customExtensionNumber)">
            <i class="ico ico-help"></i>
            <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="form-grouped-group form-grouped-group--value">
      <template v-if="(formDatas.extension || formDatas.extensionCode) && !isLoadExtensions && !isLoadExtensionsCode">
        <div class="form-group form-group--is-placeholder form-group--value"
          :class="{'is-not-empty': formDatas.value, 'is-help': helps && helps.value, 'is-error': form.items.$dirty && form.items.$each.$response.$data[index].value.$error}">
          <div class="form-label-container">
            <label :for="'value-' + index">{{ Translator('front.cart.add.assurance.value_short')}}</label>
          </div>
          <input type="number" class="form-control" v-model="formDatas.value" :id="'value-' + index" min="1" autocomplete="off" @focus="onFocusAssurance" @blur="onBlurAssurance" @change="onChangeAssurance" @keyup="onChangeAssurance">
          <div class="form-card-help" v-if="helps && helps.value">
            <button type="button" id="help-year" @click="onShowHelp($event, helps.value)">
              <i class="ico ico-help"></i>
              <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
            </button>
          </div>
        </div>
        <p class="card-grouped-input-suffix">€</p>
      </template>
    </div>
    <div class="form-grouped-group form-grouped-options">
      <template v-if="formDatas.value && (formDatas.extension || formDatas.extensionCode) && !isLoadExtensions && !isLoadExtensionsCode">
        <div class="card-grouped-options-wrapper">
          <p class="card-grouped-label">{{ Translator('front.cart.add.card.options')}} : </p>
          <div class="card-grouped-options">
            <template v-if="options && !isLoadingOptions">
              <label class="card-grouped-option" v-for="item in options" :key="item.id">
                <input type="checkbox" :value="item.variants[0]['@id']" v-model="formDatas.options" @change="onUpdateTotal">
                <div class="card-grouped-option-item">
                  <i class="ico ico-write-new" v-if="item.variants[0].code.includes('gradereport')"></i>
                  <i class="ico ico-photo" v-if="item.variants[0].code.includes('photographie')"></i>
                  <i class="ico ico-monochrome" v-if="item.variants[0].code.includes('monochrome')"></i>
                  <i class="ico ico-protection" v-if="item.variants[0].code.includes('protection')"></i>
                </div>
                <p class="card-grouped-option-label">{{ item.variants[0].name }}</p>
              </label>
              <label class="card-grouped-option">
                <input type="checkbox" :value="true" v-model="formDatas.insurance" @change="onUpdateTotal">
                <div class="card-grouped-option-item">
                  <i class="ico ico-protection"></i>
                </div>
                <p class="card-grouped-option-label">{{ Translator('front.cart.add.card.insurance') }}</p>
              </label>
            </template>
            <div class="card-grouped-loader" v-if="!options || isLoadingOptions"></div>
          </div>
        </div>
        <p class="card-grouped-item-total">{{ (total || 0) | toFixed(2) }} €</p>
      </template>
    </div>

    <help v-if="isHelpShow" v-bind:datas="helpDatas" :origin="helpParent" @close="isHelpShow = false"></help>
  </div>
</template>
<script>
import debounce from 'debounce';
import GamesService from '@/services/Games';
import ProductsService from '@/services/Products';
import Help from '@/components/Help';

export default {
  props: ['form', 'formDatas', 'games', 'index'],
  name: 'cart-grouped-item',
  components: {
    Help
  },
  data () {
    return {
      total: 0,
      onScroll: null,
      helps: {},
      helpsGlobal: {},
      isHelpShow: false,
      helpDatas: null,
      helpParent: null,
      insurance_value: null,
      isLoadingOptions: false,
      isLoadExtensions: false,
      isLoadExtensionsCode: false,
      isOpenVueSelect: false,
      currentGame: null,
      extensions: null,
      extensionsCode: null,
      languages: null,
      options: null,
    }
  },

  created() {
    this._getOptions = this._getOptions.bind(this);
    this._getOptions = debounce(this._getOptions, 600);
  },
  mounted() {
    this.onChangeGame(false);
    this._getHelps(true);
  },

  methods: {
    onChangeExtension() {},

    onBlurAssurance(pEvt) {
      this.onChangeAssurance();
      this.onBlur(pEvt);
    },

    onFocusAssurance(pEvt) {
      this.onChangeAssurance();
      this.onFocus(pEvt);
    },

    onFocus(pEvt) {
      pEvt.target.closest('.form-group').classList.add('is-focus');
    },

    onBlur(pEvt) {
      const el = pEvt.target;
      const group =  el.closest('.form-group');
      group.classList.remove('is-focus', 'is-error');
    },

    onUpdateTotal() {
      this._updateTotal();
    },

    onChangeAssurance() {
      if(this.formDatas.value < 1) this.formDatas.value = '';
      else this.insurance_value = this.formDatas.value * 2 / 100;
      this._getOptions();
      this._updateTotal();
    },

    onChangeGame( forceClean = true ) {
      const game = GamesService.getGame( this.formDatas.game, '@id' );
      this.currentGame = game;
      this.formDatas.currentGame = game;
      this.languages = game.languages;
      if( forceClean ) {
        this.formDatas.language = this.currentGame.languages[0]['@id'];
        this.formDatas.extension = null;
        this.formDatas.extensionCode = null;
        this.extensions = null;
        this.extensionsCode = null;
        this.insurance_value = 0;
        this.formDatas.value = '';
        this.formDatas.insurance = false;
      } else {
        if( !this.formDatas.language ) this.formDatas.language = this.currentGame.languages[0]['@id'];
        if( this.formDatas.value ) {
          this.insurance_value = this.formDatas.value * 2 / 100;
          this._getOptions(false, () => {
            this._updateTotal();
          });
        }
      }
      if( this.currentGame.code === 'pokemon' || this.currentGame.code === 'magic' ) this._getExtensions();
      else this._getExtensionsCode();

      this._getHelps();
    },

    onChangeLanguage() {
      this.formDatas.extension = null;
      this.formDatas.extensionCode = null;
      this.extensions = null;
      this.extensionsCode = null;
      this.insurance_value = 0;
      this.formDatas.value = '';
      this.formDatas.insurance = false;
      if( this.currentGame.code === 'pokemon' || this.currentGame.code === 'magic' ) this._getExtensions();
      else this._getExtensionsCode();

      this._getHelps();
    },

    onSelectedVueSelect(code) {
      const el = this.$refs[code];
      setTimeout(() => {
        el.open = false;
      });
    },

    onTouchVueSelect(code) {
      const el = this.$refs[code];
      el.$refs.search.focus();
    },

    onFocusVueSelect(code) {
      this.$nextTick( () => {
        if(this.$refs[code]?.$el) {
          const el = this.$refs[code].$el;
          el.closest('.form-group').classList.add('is-focus');
          this.isOpenVueSelect = true;
        }
      });
    },

    onBlurVueSelect(code) {
      this.$nextTick( () => {
        if(this.$refs[code]?.$el) {
          const el = this.$refs[code].$el;
          const group =  el.closest('.form-group');
          group.classList.remove('is-focus');

        }
        this.isOpenVueSelect = false;
      });
    },

    onShowHelp(pEvt, help) {
      const helpParent = pEvt.target.closest('.form-group');
      if(this.isHelpShow && this.helpParent === helpParent) {
        this.isHelpShow = false;
        document.body.classList.remove('is-popin-help-open');
        return;
      }
      this.helpParent = helpParent;
      this.helpDatas = help;
      this.isHelpShow = true;
      document.body.classList.add('is-popin-help-open');
    },

    _getOptions( forceClean = true, cb = null ) {
      const value = this.formDatas.value * 100;
      if(this._previousAssurance === this.formDatas.value || value === 0) return;
      this._previousAssurance = this.formDatas.value;
      this.isLoadingOptions = true;
      this.options = null;
      if( forceClean ) this.formDatas.options = [];
      const req = ProductsService.getAll({
        declaredValue: value
      });
      req.then( res => {
        this.options = res.data['hydra:member'];
        this.isLoadingOptions = false;
        if(cb) cb();
        return this.options;
      })
      return req;
    },

    _getHelps(global = false) {
      return new Promise((resolve) => {
        this.loadingHelps = true;
        if(global) this.helpsGlobal = null;
        else this.helps = null;
        GamesService.getHelps({
          ...(this.currentGame && { games: this.currentGame['@id'] }),
          ...(this.formDatas.language && { languages: this.formDatas.language })
        }).then( res => {
          if(global) this.helpsGlobal = {};
          else this.helps = {};
          res.data['hydra:member'].forEach(item => {
            if(global) {
              this.helpsGlobal[item.formKey] = {
                title: item.title,
                content: item.helpText
              }
            } else {
              this.helps[item.formKey] = {
                title: item.title,
                content: item.helpText
              }
            }
          });
          resolve(global ? this.helpsGlobal : this.helps);
        }).then(() => {
          this.loadingHelps = false;
        });
      })
    },

    _getExtensions() {
      this.isLoadExtensions = true;
      const datas = {
        languages: this.formDatas.language,
        'block.game': this.currentGame['@id']
      };
      GamesService.getExtensions(datas).then( res => {
        this.extensions = res.data['hydra:member'];
        if(this.extensions.length === 1) {
          this.formDatas.extension = this.extensions[0]['@id'];
        }
      }).then( () => {
        this.isLoadExtensions = false;
      });
    },

    _getExtensionsCode() {
      this.isLoadExtensionsCode = true;
      const datas = {
        game: this.currentGame['@id'],
        'cardExtensions.languages': this.formDatas.language
      };
      GamesService.getCodeExt(datas).then( res => {
        this.extensionsCode = res.data['hydra:member'];
        if(this.extensionsCode.length === 1) {
          this.formDatas.extensionCode = this.extensionsCode[0]['@id'];
        }
      }).then( () => {
        this.isLoadExtensionsCode = false;
      });
    },

    _updateTotal() {
      const cardValue = this.formDatas.value * 100;
      if(this.currentGame && this.currentGame.productVariant) {
        GamesService.getTotalPrice(this.formDatas.game, cardValue, this.formDatas.serviceType).then( res => {
          let total = res.data.priceTtc / 100;
          if(this.formDatas.insurance) total += parseFloat(this.insurance_value);
          if(this.formDatas.options.length > 0) {
            this.options.forEach( product => {
              const variant = product.variants[0];
              if(this.formDatas.options.includes(variant['@id'])) {
                total += variant.priceTtc / 100;
              }
            })
          }
          this.total = total;
        })
      } else this.total = 0;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style lang="scss">
body.is-popin-help-open {
  .cart-wrapper {
    .scroll-container {
      -webkit-overflow-scrolling: initial !important;
    }
  }
}
</style>
<style scoped lang="scss">
.card-grouped-loader {
  @include loader($black, .8);
  @include tablet-max {
    min-height: rem(60);
    min-width: rem(80);
  }
  @include desktop {
    min-width: rem(80);
    @include loader($black, .5);
  }
}
.viewer-element .std-form .cart-grouped-row {
  position: relative;
  display: flex;
  gap: rem(7);
  align-items: center;
  width: 100%;
  @include tablet-max {
    flex-direction: column;
    padding: 0 rem(5);
    padding-right: 0;
  }
  @include desktop {
    font-size: rem(12);
  }
  .form-card-help {
    top: 50%;
    right: rem(5);
    @include desktop {
      button {
        font-size: rem(20);
        line-height: rem(26);
      }
    }
  }
  .form-group {
    width: 100%;
    @include tablet-max {
      margin-bottom: rem(5);
      &.form-group--game,
      &.form-group--language {
        width: 40%;
      }
      &.form-group--game {
        min-width: rem(90);
      }
      &.form-group--language {
        min-width: rem(60);
      }
      &.form-group--language .v-select {
        &::v-deep {
          .vs__selected-options {
            padding-top: rem(13);
            padding-bottom: rem(13);
          }
        }
      }
    }
    @include desktop {
      &.form-group--is-placeholder {
        .form-label-container {
          white-space: nowrap;
          padding: rem(4) rem(2);
        }
        &.is-focus,
        &.is-not-empty {
          .form-label-container {
            font-size: rem(7);
            top: rem(-8);
            left: rem(5);
          }
        }
        &:not(.is-not-empty):not(.is-focus) .form-label-container {
          font-size: rem(10);
          margin-bottom: 0;
          @include desktop {
            left: rem(4);
            top: rem(5);
            font-size: rem(9);
          }
        }
      }
      &.form-group--service {
        width: rem(90);
        min-width: calc( 100% - (#{rem(75)} + #{rem(45)} + #{rem(14)}));
      }
      &.form-group--game {
        width: rem(75);
      }
      &.form-group--language {
        width: rem(45);
      }
      &.form-group--extension {
        width: 100%;
      }
      &.form-group--extension-number {
        width: 100%;
      }
      &.form-group--value {
        width: calc(100% - #{rem(15)});
      }
    }
  }
  .form-grouped-group {
    display: flex;
    align-items: center;
    gap: rem(7);
    @include tablet-max {
      width: 100%;
    }
    @include desktop {
      &.form-grouped-group--extension {
        min-width: rem(200);
        width: 30%;
      }
      &.form-grouped-group--extension-number {
        min-width: rem(80);
        width: 15%;
      }
      &.form-grouped-group--card {
        width: 30%;
        max-width: rem(300);
      }
      &.form-grouped-group--value {
        width: 8%;
        min-width: rem(90);
      }
      &.form-grouped-options {
        margin-right: 0;
        margin-left: auto;
        min-width: rem(250);
        flex-shrink: 0;
      }
    }
  }
  .card-grouped-item-total {
    margin-right: 0;
    margin-left: auto;
    color: $black;
    font-weight: bold;
    white-space: nowrap;
    @include tablet-max {
      margin-top: rem(25);
    }
  }
  .card-grouped-options-wrapper {
    display: flex;
    align-items: center;
    @include tablet-max {
      gap: rem(3);
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
    }
    @include desktop {
      gap: rem(3);
      margin-right: 0;
      margin-left: auto;
    }
  }
  .card-grouped-label {
    white-space: nowrap;
    font-size: rem(12);
    @include desktop {
      font-size: rem(10);
    }
  }
  .card-grouped-options {
    display: flex;
    gap: rem(5);
    @include desktop {
      gap: rem(3);
      flex-shrink: 0;
      width: rem(140);
    }
  }
  .card-grouped-option {
    position: relative;
    [type=checkbox] {
      @include absolute;
      z-index: 1;
      opacity: 0;
      &:checked + .card-grouped-option-item {
        border-color: $color-second;
        color: $black;
      }
    }
    @include desktop {
      &:hover, &:focus-visible {
        .card-grouped-option-label {
          opacity: 1;
          transition: opacity $transition-in-hover;
        }
      }
    }
  }
  .card-grouped-option-label {
    position: absolute;
    left: 50%;
    top: rem(-3);
    z-index: 20;
    padding: rem(2) rem(5);
    transform: translate(-50%, -100%);
    background: rgba($black, .7);
    color: $white;
    font-size: rem(8);
    opacity: 0;
    transition: opacity $transition-out-hover;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
    border-radius: rem(2);
  }
  .card-grouped-option-item {
    border: rem(1) solid $grey-light;
    border-radius: rem(6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: $grey-dark;
    cursor: pointer;
    width: rem(40);
    height: rem(40);
    .ico {
      font-size: rem(26);
    }
    @include desktop {
      width: rem(32);
      height: rem(32);
      .ico {
        font-size: rem(20);
      }
    }
  }
  .form-group.is-help {
    .v-select {
      ::v-deep {
        .vs__selected-options {
          width: calc(100% - #{rem(50)});
        }
        .vs__actions {
          margin-right: rem(30);
        }
      }
    }
    .form-control {
      padding-right: rem(20);
    }
  }
  @include desktop {
    .form-control,
    .form-group,
    .v-select {
      font-size: rem(10);
      margin-bottom: 0;
      height: rem(32);
    }
    .form-control {
      select, input {
        height: rem(32);
        line-height: 1;
      }
    }
  }
  .form-group {
    &.form-group--language {
      .v-select {
        ::v-deep {
          .vs__dropdown-option {
            img {
              max-height: rem(30);
            }
          }
          @include tablet-max {
            .vs__selected img {
              max-height: rem(25);
            }
            .vs__dropdown-menu {
              left: auto;
              right: 0;
            }
          }
        }
      }
    }
    &.form-group--game,
    &.form-group--language {
      .v-select {
        ::v-deep {
          .vs__selected-options {
            padding: rem(5) rem(2);
          }
        }
      }
    }
  }
  .v-select {
    ::v-deep {
      .vs__selected {
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .vs__dropdown-option {
        img {
          width: 100%;
          object-fit: contain;
          max-height: rem(30);
          padding: rem(5);
        }
      }

      @include desktop {
        .vs__actions {
          height: rem(30);
        }
        .vs__selected-options {
          height: rem(30);
        }
      }





      // &.vs--single.vs--loading .vs__selected,
      // &.vs--single.vs--open .vs__selected {
      //   top: 0;
      // }
      // .vs__actions {
      //   height: 100%;
      // }
      // .vs__selected-options {
      //   padding: rem(5) rem(5);
      //   height: 100%;
      // }
      // @include desktop {
      //   .vs__actions {
      //     height: rem(30);
      //   }
      //   .vs__selected-options {
      //     height: rem(30);
      //   }
      // }
      // .vs__dropdown-option {
      //   img {
      //     max-height: rem(40);
      //     width: 100%;
      //     object-fit: contain;
      //     padding: rem(5);
      //   }
      // }
    }
  }
  .card-grouped-input-suffix {
    color: $black;
  }
  .cart-grouped-number {
    font-weight: bold;
    color: $blue-udark;
    flex-shrink: 0;
    text-align: right;
    @include tablet-max {
      position: absolute;
      top: rem(15);
      left: rem(-5);
      transform: translateX(-100%);
    }
    @include desktop {
      width: rem(20);
      font-size: rem(12);
    }
  }
}
</style>
